import { MainLayout } from '../../design-system/Templates';
import { Header } from '@/design-system/Organisms';
import { headerConfig } from '@/design-system/Organisms/Header/Header.config';
import { Footer } from '@/design-system/Organisms';
import DashboardTemplate from '@/design-system/Templates/DashboardTemplate';

const DashboardPage = () => {

    return (
        <MainLayout
            header={<Header {...headerConfig} />}
            sidebar={null}
            className=""
            footer={<Footer />}
            topBanner={null}
        >
            <DashboardTemplate />
        </MainLayout >
    );
};

export default DashboardPage;
